import { Theme, makeStyles, createStyles, fade } from '@material-ui/core/styles';
import { CommonButtonTypes } from 'Common/Types/Types';
export const useStyles = makeStyles<Theme, CommonButtonTypes>((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
			minWidth: 300,
			width: '30%',
			margin: '0 auto',
			
		},
		search: {
			position: 'relative',
			// borderRadius: theme.shape.borderRadius,
			// backgroundColor: fade(theme.palette.common.white, 0.15),
			// '&:hover': {
			// 	backgroundColor: fade(theme.palette.common.white, 0.25),
			// },
			margin: '1rem 1rem 0',
			width: '30%',
			background:' #f8f9fa !important',
			borderRadius:'30px',
			[theme.breakpoints.down('sm')]: {
				marginLeft: theme.spacing(1),
				width: '90% !important',
				float: 'right',
				margin: '0 1rem',
				marginTop:'1rem !important'
			},
		},
		searchIcon: {
			padding: theme.spacing(0, 2),
			height: '100%',
			position: 'absolute',
			pointerEvents: 'none',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		inputRoot: {
			color: 'inherit',
		},
		inputInput: {
			padding: theme.spacing(1, 1, 1, 0),
			paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
			transition: theme.transitions.create('width'),
			width: '30%',
			[theme.breakpoints.up('sm')]: {
				width: '12ch',
				'&:focus': {
					width: '20ch',
				},
			},
		},
		listItem: {
			listStyleType: 'none',
			display: 'flex',
			flexDirection: 'column',
			width: '100%',
			height: '100vh',
		},
		links: {
			color: '#78393D',
			textDecoration: 'none',
			width: '100%',
			'&:hover': {
				color: 'rgb(80 35 38)',
			},
		},
		pagination: {
			position: 'fixed',
			padding: '.2rem !important',
			display: 'flex',
			justifyContent: 'center',
			bottom: 0,
			width:'100%',
			background:'#f8f9fa !important '
		},
		image: {
			width: '250px',
			objectFit: 'contain',
			margin: '0 3rem',
			padding: '1rem 0',
		},
		loading: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			alignItems: 'center',
			marginTop: '3rem',
		}
	}),
);
